import { render, staticRenderFns } from "./dashboardpool.vue?vue&type=template&id=3664dcf5&scoped=true"
import script from "./dashboardpool.vue?vue&type=script&lang=js"
export * from "./dashboardpool.vue?vue&type=script&lang=js"
import style0 from "./dashboardpool.vue?vue&type=style&index=0&id=3664dcf5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3664dcf5",
  null
  
)

export default component.exports